import { useContext } from "react";
import {
  OrderContext,
  IOrderContextType,
} from "../../../contexts/OrderContext";

// Re-export the order types so existing imports from this module keep working.
export type {
  CancelAllOrderFailure,
  CancelAllOrdersResponse,
} from "../../../contexts/OrderContext";

// Reader for the shared `/orders` data + order actions.
//
// The actual SWR subscription, websocket realtime reconciliation, polling and
// order actions live ONCE in <OrderContextProvider> (src/contexts/OrderContext).
// This hook only reads that single source of truth, so the many call sites no
// longer each spin up their own `/orders` fetch driver + realtime effect.
export const useOrder = (): IOrderContextType => {
  const ctx = useContext(OrderContext);
  if (!ctx) {
    throw new Error("useOrder must be used within an <OrderContextProvider>");
  }
  return ctx;
};
